import {useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {Helmet} from "react-helmet";
import {Container, Grid, Header, Icon, Image, Segment, List} from "semantic-ui-react";
import isEmpty from 'lodash/isEmpty'
import OfferCards from "../components/offer_cards";
import Layout from "../components/layout";

const Company = ({is_mobile}) => {
  const { company_name } = useParams()
  const navigate = useNavigate();
  const [offer_data, setOfferData] = useState({data: [], is_loading: true})
  const [socials, setSocials] = useState({})
  const [error, setError] = useState(false)

  const currentDate = new Date();
  const currentMonthAbbreviation = currentDate.toLocaleString('default', { month: 'short' });
  let suit_case_icon = 'https://static-images123.s3.eu-west-3.amazonaws.com/no-photos.png'
  let lens_icon = 'https://static-images123.s3.eu-west-3.amazonaws.com/lens-logo.png'

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/company-offers/${company_name}`)
        .then((res) => res.json())
        .then((json) => {
          setOfferData({data: json, is_loading: false})
          setError(isEmpty(json))
        })

    fetch(`${process.env.REACT_APP_BASE_URL}/company-socials/${company_name}`)
        .then((res) => res.json())
        .then((json) => {
          setSocials(json)
        })
    }, [])

  if (company_name) {
    document.title = `${company_name.replaceAll("-", " ")} Jobs and Careers (${currentMonthAbbreviation} 2025)`
  }

  if (error === true) {
    navigate('/', {replace: true});
  }

  return (
    <>
      <Layout is_mobile={is_mobile} header_data={{header_text: `${company_name.replaceAll("-", " ")} jobs`}}>
        {company_name &&
          <Helmet>
            <link rel="canonical" href={`${process.env.REACT_APP_PRINCIPAL_URL}/companies/${company_name}`}/>
            <meta property="og:url" content={`${process.env.REACT_APP_PRINCIPAL_URL}/companies/${company_name}`}/>
            <meta property="og:title" content={`${company_name.replaceAll("-", " ")} Jobs and Careers (${currentMonthAbbreviation} 2025)`}/>
          </Helmet>
        }
        {socials !== null &&
            <Helmet>
              <meta name="description" content={`Explore ${company_name.replaceAll("-", " ")} Jobs in ${currentMonthAbbreviation} 2025, for positions such as ${offer_data.data.slice(0, 2).map(offer => offer.title).join(', ')} `}/>
              <meta property="og:description" content={`Explore ${company_name.replaceAll("-", " ")} Jobs in ${currentMonthAbbreviation} 2025, for positions such as ${offer_data.data.slice(0, 2).map(offer => offer.title).join(', ')} `}/>
            </Helmet>
        }

        {/*<h2>{socials && socials.description}</h2>*/}
        <Container>
          <Grid verticalAlign='middle'>
            <Grid.Row>
              <Grid.Column width={is_mobile ? 0 : 3}>
              </Grid.Column>

              <Grid.Column textAlign="center" width={is_mobile ? 16 : 10}>
                <Grid.Row>
                  <Header as="h2">
                    <Image verticalAlign="middle" className="companies_page_logo" circular fluid alt="company logo"
                           src={offer_data.data.length !== 0 ? offer_data.data[0].logo : suit_case_icon}>
                    </Image>
                  <Header.Content  className="companies_page_name">
                    {company_name.replaceAll("-", " ")}
                  </Header.Content>
                  </Header>
                  {socials && socials !== {} &&
                    <>
                      {socials.website && socials.website !== "null" && <a target="_blank" href={socials.website} rel="nofollow noopener noreferrer"><Icon size="big" name="globe" color="black"/></a>}
                      {socials.twitter && socials.twitter !== "null" && <a target="_blank" href={"https://twitter.com/" + socials.twitter.replace("@", "")} rel="nofollow noopener noreferrer"><Icon size="big" name="twitter" color="blue"/></a>}
                      {socials.linkedin && socials.linkedin !== "null" && <a target="_blank" href={"https://www.linkedin.com/company/" + socials.linkedin} rel="nofollow noopener noreferrer"><Icon size="big" name="linkedin" color="blue"/></a>}
                      {socials.discord && socials.discord !== "null" && <a target="_blank" href={socials.discord} rel="nofollow noopener noreferrer"><Icon className="discord-icon" size="big" name="discord" color="blue"/> </a>}
                      {socials.lens && socials.lens !== "null" && <a target="_blank" href={"https://www.lensfrens.xyz/" + socials.lens.replace("@", "") + ".lens"} rel="nofollow noopener noreferrer"><Image alt="lens logo" inline size="big" src={lens_icon}/></a>}
                    </>
                }

                </Grid.Row>

              </Grid.Column>
              <Grid.Column width={is_mobile ? 0 : 3}>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={3}/>
              <Grid.Column width={is_mobile ? 16 : 10}>
                <OfferCards is_mobile={is_mobile} offers={offer_data.data}/>
              </Grid.Column>
              {/*TODO - Add offer pagination that add page index to request*/}
              <Grid.Column width={3}/>
            </Grid.Row>
          </Grid>
        </Container>
      </Layout>
    </>
  )
}

export default Company;